if (!customElements.get('sticky-tabs')) {
  customElements.define('sticky-tabs', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const link = event.target.closest('button[data-anchor], a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        let anchor = link.dataset.anchor;
        if (anchor === undefined) {
          const url = new URL(link.href, window.location.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
          anchor = url.hash.slice(1);
        }
        event.preventDefault();
        let target;
        try { target = document.getElementById(decodeURIComponent(anchor)); } catch { return; }
        if (!target) return;
        if (target.hasAttribute('data-navigation-anchor')) target = target.closest('.shopify-section') || target;
        const header = document.querySelector('sticky-header');
        const headerHeight = header ? document.querySelector('.section-header')?.getBoundingClientRect().height || header.offsetHeight : 0;
        const tabsHeight = this.closest('.section-sticky-tabs').getBoundingClientRect().height;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - tabsHeight;
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
  });
}
